import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const baseStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 15000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative',
    inset: 'unset',
    padding: '0',
    borderRadius: '12px',
    overflow: 'hidden',
  },
};

export const ModalBase = ({
  isOpen,
  onRequestClose,
  width,
  maxWidth,
  children,
}) => {
  const customStyles = {
    overlay: baseStyles.overlay,
    content: {
      ...baseStyles.content,
      width,
      maxWidth,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      style={customStyles}
      ariaHideApp={false}>
      {children}
    </Modal>
  );
};

ModalBase.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  children: PropTypes.node,
};

ModalBase.defaultProps = {
  width: '90%',
  maxWidth: '500px',
  children: null,
};

export default ModalBase;
